module.exports = __webpack_public_path__ + "static/equipe_gastrocirurgica_jaleco-38329d6912b20ff8f78fa918af42d174.png";